import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectCurrentReportContextualActionsLoading } from '../state/reports.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'detail-page-headerbar report-header-bar',
    },
    selector: 'ndt-report-header-bar',
    styleUrls: ['./report-header-bar.scss'],
    templateUrl: 'report-header-bar.component.html',
    standalone: false
})
export class ReportHeaderBarComponent implements OnInit {
   @Input() showDownloadOptions = false;

   @Input() showConfigureButton = true;

   @Input() reportName: string;

   @Input() pageType: string;

   @Input() allowExcel = true;

   @Input() allowHtml = true;

   @Input() allowPdf = true;

   @Input() allowMemorize = false;

   @Output() configure = new EventEmitter<void>();

   @Output() downloadExcel = new EventEmitter<void>();

   @Output() downloadHtml = new EventEmitter<void>();

   @Output() downloadPdf = new EventEmitter<void>();

   @Output() saveParameters = new EventEmitter<void>();

   isLoading$: Observable<boolean>;

   constructor(private store: Store) {}

   ngOnInit(): void {
      this.isLoading$ = this.store.pipe(select(selectCurrentReportContextualActionsLoading));
   }

   onConfigure(): void {
      this.configure.emit();
   }

   onDownloadExcel(): void {
      this.downloadExcel.emit();
   }

   onDownloadHtml(): void {
      this.downloadHtml.emit();
   }

   onDownloadPdf(): void {
      this.downloadPdf.emit();
   }

   onSaveParameters(): void {
      this.saveParameters.emit();
   }
}
